module.exports = __webpack_public_path__ + "static/media/issue7.ae8b5b37.webp";